module.exports = __webpack_public_path__ + "media/mixkit-notification-bell-592.7eb48c29.wav";